var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 52,
    viewBox: "0 0 47 52",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "4wci0r0yqa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119DF3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0764E3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.504 36.123V15.82a5.668 5.668 0 0 0-2.835-4.909L26.087.759a5.672 5.672 0 0 0-5.669 0L2.835 10.911A5.668 5.668 0 0 0 0 15.82v20.303a5.671 5.671 0 0 0 2.835 4.91l17.583 10.151a5.667 5.667 0 0 0 5.669 0l17.582-10.151a5.671 5.671 0 0 0 2.835-4.91",
    fill: "url(#4wci0r0yqa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.264 15c.465 0 .863.306 1.017.736l2.441 2.443a1.086 1.086 0 0 1-1.447 1.615l-.089-.08-.837-.837v16.988c0 .627-.486 1.135-1.085 1.135-.56 0-1.02-.442-1.08-1.01l-.006-.125V18.868l-.825.825a1.086 1.086 0 0 1-1.447.079l-.088-.08a1.086 1.086 0 0 1-.08-1.447l.08-.088 2.435-2.438c.159-.42.551-.719 1.01-.719zm-7.825 7.405.088.079 2.695 2.695a1.086 1.086 0 0 1-1.447 1.615l-.088-.08-.836-.835v10.399c0 .399-.485.722-1.085.722-.56 0-1.02-.282-1.08-.643l-.006-.079V25.867l-.826.826a1.086 1.086 0 0 1-1.448.079l-.088-.08a1.086 1.086 0 0 1-.079-1.447l.08-.088 2.673-2.673a1.086 1.086 0 0 1 1.447-.08zm16.996 0 .088.079 2.695 2.695a1.086 1.086 0 0 1-1.447 1.615l-.089-.08-.835-.835v10.399c0 .399-.486.722-1.085.722-.56 0-1.02-.282-1.08-.643l-.006-.079V25.866l-.826.827a1.086 1.086 0 0 1-1.448.079l-.088-.08a1.086 1.086 0 0 1-.08-1.447l.08-.088 2.673-2.673a1.086 1.086 0 0 1 1.448-.08z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.3f45216e2f2b15e36d5befaacf07d97d.svg";
export { ForwardRef as ReactComponent };